import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { MapSet, mapSetSchema } from '../schemas/map-set.schema';

/**
 * Edits a Map Set
 * @param mapSet The Map Set being edited
 * @returns Data object indicating success and the updated Map Set
 */
export function putMapSets(this: unknown, mapSet: Partial<MapSet>) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment.resolve(this).mapSetsUrl}/${
          mapSet.customMapsetId ?? -1
        }`,
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            ...mapSet,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: mapSetSchema,
        message: z.string(),
      })
    )
  );
}
